import { Model, Schema } from "src/engine/modules/model/classes"
import memoize from "lodash/memoize"

const entityName = `planEventTypes`

export default memoize(
  planId =>
    new Model({
      name: entityName,
      getRestUrn: () => `/plans/${planId}/events/types`,
      primaryKey: `id`,
      schema: new Schema({
        startDateTime: new Schema.types.DateTime(`ms`),
        endDateTime: new Schema.types.DateTime(`ms`),
      }),
    }),
)
